export const ROUTE_PARAMS = {
  ORGANIZATION: 'organization',
  OWNER: 'owner',
  DE: 'de',
  FR: 'fr',
  ES: 'es',
  AT: 'at',
  BE: 'be',
  NL: 'nl',
  PT: 'pt',
  IT: 'it',
} as const;

export const ROUTE_PARAMS_COUNTRIES = [
  ROUTE_PARAMS.DE,
  ROUTE_PARAMS.FR,
  ROUTE_PARAMS.ES,
  ROUTE_PARAMS.AT,
  ROUTE_PARAMS.BE,
  ROUTE_PARAMS.NL,
  ROUTE_PARAMS.PT,
  ROUTE_PARAMS.IT,
] as const;

export type RouteParams = (typeof ROUTE_PARAMS)[keyof typeof ROUTE_PARAMS];
